<template>
  <q-select
    outlined
    :modelValue="modelValue"
    :label="label"
    @update:modelValue="$emit('update:modelValue', $event)"
    use-input
    hide-selected
    fill-input
    :options="options"
    :error="error"
    :loading="loading"
    hide-bottom-space
  >
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey"> No results </q-item-section>
      </q-item>
    </template>
    <template v-slot:error>
      <span
        v-for="err in errors"
        :key="err"
        >{{ err }}</span
      >
    </template>
  </q-select>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  modelValue: [String, Number, Object],
  errors: [String, Array],
  label: {
    type: String,
    default: 'Empresa',
  },
  tipo: [String],
});
defineEmits(['update:modelValue']);
const options = ref([
  { label: 'FRIOLATINA', value: '1' },
  { label: 'ACEROLATINA', value: '3' },
]);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const loading = ref(false);
</script>
